import React from 'react';
import PropTypes from 'prop-types';
import { TextStyle } from '@lavu-pos/lavu-react-components';
import { Colors } from 'modules/utils';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import { COLLAPSE_ALL, EXPAND_ALL } from './constants';

const TitleSectionStyle = styled.div`
	display: flex;
	align-items: center;
	flex-wrap: wrap;
`;

const propTypes = {
	elementId: PropTypes.string,
	expandAccordions: PropTypes.bool,
	toggleAccordions: PropTypes.func,
	expandLabel: PropTypes.bool.isRequired,
	title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
};

export const TitleSection = ({
	elementId,
	expandAccordions,
	toggleAccordions,
	title,
	expandLabel,
}) => {
	const toggleText = expandAccordions ? (
		<FormattedMessage id="collapseAll" defaultMessage={COLLAPSE_ALL} />
	) : (
		<FormattedMessage id="expandAll" defaultMessage={EXPAND_ALL} />
	);

	return (
		<TitleSectionStyle id={elementId}>
			<TextStyle
				id={`${elementId}-title`}
				variation="strong"
				fontSize={17}
				fontWeight="600"
				color={Colors.PRIMARY_TEXT}
			>
				{title}
			</TextStyle>
			{expandLabel && (
				<TextStyle
					id={`${elementId}-expand-collapse`}
					variation="strong"
					style={{ marginLeft: 'auto', fontSize: 12, cursor: 'pointer' }}
					onClick={toggleAccordions}
				>
					{toggleText}
				</TextStyle>
			)}
		</TitleSectionStyle>
	);
};

TitleSection.propTypes = propTypes;
